var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"d-flex mx-1",on:{"submit":function($event){$event.preventDefault();return _vm.fetchInformation()}}},[_c('vue-simple-suggest',{ref:"suggestComponent",class:_vm.customClass,attrs:{"type":"search","placeholder":_vm.$t('comp_navbar--searchPlaceholder'),"aria-label":"Search","debounce":200,"controls":{
      selectionUp: [38, 33],
      selectionDown: [40, 34],
      select: [13, 36],
      showList: [40],
      hideList: [27, 35],
    },"nullable-select":true,"value-attribute":"id","display-attribute":"text","list":_vm.getAutoCompleteSuggest},on:{"select":_vm.onSuggestSelect},model:{value:(_vm.searchWord),callback:function ($$v) {_vm.searchWord=$$v},expression:"searchWord"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }